<template>
  <div class="visited-history" v-if="finished">
    <van-dropdown-menu>
      <van-dropdown-item v-model="value1" :options="option1" @change="changeMenuItem" />
    </van-dropdown-menu>
    <div class="do-list" v-if="dolist && dolist.length">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="
          {
          }
        "
      >
        <div class="do-list-item flex" v-for="item of dolist" :key="item.id" @click="handleItem(item)">
          <!-- <div class="flex flex-b">
            <span class="title mb"
              >{{ item.name }} {{ item.dept ? `（${item.dept}）` : '' }}</span
            > -->
          <!-- <span @click.stop="handleVis(item)" v-if="renderAlign(item)"
              >再次预约</span
            > -->
          <!-- <span @click.stop="handleSave(item.id)" v-if="item.auditStatus == 4"
              >提交暂存</span
            > -->
          <!-- <span @click.stop="handleVis(item)" v-if="item.auditStaus == 2"
              >重新提交</span
            > -->
          <!-- </div>
          <div class="mb flex flex-b">
            <span>{{ item.startTime }} - {{ item.endTime }}</span>
          </div> -->
          <div class="box">
            <div class="content">
              <div class="cause flex flex-b flex-vc">
                <span class="">被访人：{{ item.name }}</span>
                <van-tag plain type="success" v-if="item.auditStatus == 1">已同意</van-tag>
                <van-tag plain type="primary" v-if="item.auditStatus == 0">待审批</van-tag>
                <van-tag plain type="danger" v-if="item.auditStatus== 2">已拒绝</van-tag>
                <van-tag plain type="danger" v-if="item.auditStatus== -1">已过期</van-tag>
                <van-tag plain type="success" v-if="item.auditStatus== 3">拜访完成</van-tag>
              </div>
              <div class="flex">
                <div class="">预约时间：</div>
                <div class="">{{ item.startTime }} - {{ item.endTime }}</div>
              </div>
              <!-- <div   @click="handleItem(item)">详情</div> -->
              <!-- <div class="flex flex-vc flex-b">
                <div class="sonTitle">审批状态</div>
                <div class="status tc" :class="detail.auditStatus === 2 ? 'error' : ''">{{ detail.auditStatus === 0 ? "待审批" : detail.auditStatus === 1 ? "已通过" : "已驳回" }}</div>
              </div> -->
            </div>
          </div>
          <div>
            <div class="ko" v-if="item.list && item.list.length">
              共计{{ item.list && item.list.length + 1 }}人
              <span v-for="(v, index) of item.list" :key="`list_key_${index}`"> {{ v }}&nbsp; </span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-empty description="暂无数据" v-else />
  </div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");

export default {
  data() {
    return {
      dolist: [],
      loading: false,
      finished: false,
      pageNum: 1,
      totalNum: 0,
      value1: "",
      option1: [
        { text: "全部", value: "" },
        { text: "未审批", value: "0" },
        { text: "审批通过", value: 1 },
        // { text: '审批未通过', value: -2 },
        { text: "失效", value: -1 },
        { text: "驳回", value: 2 },
        { text: "拜访完成", value: 3 },
        // { text: "暂存", value: 4 },
      ],
      auditStatus: "",
    };
  },
  created() {
    if (JSON.parse(localStorage.getItem("userInfo")).mobile) {
      this.getList();
    }
  },
  methods: {
    renderAlign(item) {
      console.log(item.auditStatus);
      return [-1, 1, 2, 3].includes(item.auditStatus);
    },
    changeMenuItem(value) {
      this.auditStatus = value;
      this.getList();
    },
    async getList() {
      try {
          console.log(this.auditStatus,this.auditStatus);
        const { data, code, msg } = await this.$https.getVisitorList({
          phone: JSON.parse(localStorage.getItem("userInfo")).mobile ? JSON.parse(localStorage.getItem("userInfo")).mobile : " ",
          // phone: '18660418819',
          auditStatus: this.auditStatus ? this.auditStatus : " ",
          // pageSize: 10,
          // pageNum: this.pageNum,
        });
        if (code !== 200) {
          this.$toast(msg);
          return false;
        }
        // this.pageNum++
        // this.totalNum = data.totalNum
        // if (this.pageNum - 1 * 10 > this.totalNum) {
        //     this.finished = true
        // }
        this.dolist =
          data &&
          data.map((item) => {
            return {
              name: item.acceptName,
              dept: item.affiliatedUnit,
              id: item.id,
              startTime: moment(item.visitorStartTime).format("YYYY-MM-DD HH:mm"),
              endTime: moment(item.visitorEndTime).format("YYYY-MM-DD HH:mm"),
              list: item.visitorName || [],
              auditStatus: item.auditStatus,
            };
          });
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.finished = true;
      }
    },
    handleItem(item) {
      const { id, auditStatus } = item;
      // if (auditStatus === 4) {
      //   this.$router.push({ path: '/updateSub', query: { id } })
      // } else {
      // }
      this.$router.push({ path: "/detailSub", query: { id, type: "vis" } });
    },
    handleVis(item) {
      if (item.auditStatus == 2) {
        this.$router.push({ path: "/updateSub", query: { id: item.id } });
      } else {
        this.$router.push({
          path: "/Subscribe",
          query: { id: item.id, type: "again" },
        });
      }
    },
    handleSave(id) {
      this.$router.push({ path: "/transientSaveSub", query: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  margin-bottom: 1.25rem;
  padding: 1rem;
  background: #ffffff;
  box-shadow: 0rem 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.9375rem;
  .content {
    margin-top: 1rem;
    > div {
      padding-bottom: 0.6875rem;
      margin-bottom: 0.6875rem;
      border-bottom: 0.0625rem solid #f4f4f6;
    }
  }
}
.title {
  height: 1rem;
  font-size: 0.75rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 1rem;
  color: #1a1a1a;
  opacity: 1;
}

.visited-history {
  /* margin: 0.6em; */
  box-shadow: 0px 4px 16px rgba(69, 91, 99, 0.08);
  background: #fff;
  border-radius: 0.3em;
  overflow: hidden;
  .do-list {
    .do-list-item {
      color: #78849e;
      flex-direction: column;
      margin: 0 0.8125rem;
      line-height: 1.8em;
      font-size: 0.8rem;
      color: #455b63;
      .title {
        font-weight: 400;
      }
      .mb {
        margin-bottom: 0.25rem;
      }
      .ko {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .van-empty {
    position: absolute;
    top: 46px;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: flex-start;
  }
}
</style>
